var $ = require('jquery');
var Analytics = require('@plaudit/analytics').Analytics;
var analytics = Analytics.getInstance();

var youtubeGAJS = (window.youtubeGAJS) ? window.youtubeGAJS : {};
youtubeGAJS = {
	// iframes: [],
	// youtubeIframes: [],
	// getYoutubeIframes: function() {
	// 	this.iframes = document.getElementsByTagName('iframe');
	// 	for (var i = 0; i < this.iframes.length; i++) {
	// 		console.log(this.iframes[i]);
	// 	}
	// },

	init: function() {
		var self = this;

		// TODO: Likely there is a better way. Look for npm module
		var tag = document.createElement('script');
		tag.id = 'iframe-demo';
		tag.src = '//www.youtube.com/iframe_api';
		var firstScriptTag = document.getElementsByTagName('script')[0];
		firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

		// Look for new youtube players when lighbox opens
		$(document).on('lightboxOpened', function() {
			self.setupYoutubePlayers();
		});
		
		// Look for youtube videos when youttube api is ready
		var originalOnYouTubeIframeAPIReady = window.onYouTubeIframeAPIReady;
		window.onYouTubeIframeAPIReady = function() {
			self.setupYoutubePlayers();

			// Call previously existing onYouTubeIframeAPIReady()
			if (originalOnYouTubeIframeAPIReady !== undefined) {
				originalOnYouTubeIframeAPIReady();
			}
		};
	},
	setupYoutubePlayers: function() {
		var YT = window.YT;
		if (YT === undefined) {
			// Will need to wait until YouTube API is ready
			return;
		}

		var self = this;

		$('iframe').each(function(index, iframe) {
			if (
				// Skip if not youtube
				iframe.src.indexOf("youtube.com") === -1
				// Skip if already setup player API on iframe
				|| iframe.player !== undefined
			) {
				return;
			}

			console.log('setting up youtube player', iframe.id, self.onPlayerReady);
			iframe.player = new YT.Player(iframe.id, {
				//host: '//www.youtube.com',
				events: {
					'onReady': self.onPlayerReady,
					'onStateChange': self.onPlayerStateChange
				}
			});
		});
	},
	onPlayerReady: function(event) {
		// console.log('onPlayerReady', arguments);
	},
	onPlayerStateChange: function(event) {
		var player = event.target;
		var iframeEl = player.getIframe();

		switch(event.data) {
			case 0:
				// YT.PlayerState.ENDED
				youtubeGAJS.sendEvent(iframeEl, 'Ended video');
				break;
			case 1:
				// YT.PlayerState.PLAYING
				youtubeGAJS.sendEvent(iframeEl, 'Playing video');
				break;
			case 2:
			// YT.PlayerState.PAUSED
				youtubeGAJS.sendEvent(iframeEl, 'Paused video');
				break;
			case 3:
			// YT.PlayerState.BUFFERING
				youtubeGAJS.sendEvent(iframeEl, 'Buffering video');
				break;
			case 5:
			// YT.PlayerState.CUED
				youtubeGAJS.sendEvent(iframeEl, 'Cued video');
				break;
		}
	},

	// Send event to Classic Analytics, Universal Analytics or Google Tag Manager
	sendEvent: function(iframeEl, action) {
		var label = iframeEl.src.split('?')[0];
		analytics.trackEvent('YouTube', action, label, undefined, false);
	}
};
module.exports = youtubeGAJS;